/**
 * 교육 접수 진행 단계. 스텝바 라벨 순서와 1:1 이다.
 *
 * 컴포넌트 파일이 아니라 여기 두는 이유: 컴포넌트 모듈이 값을 함께 export 하면
 * Fast Refresh 가 그 모듈 전체를 재평가한다(장바구니 context 와 같은 이유).
 *
 * 1·2 단계는 라우트가 같고 `?course=` 유무로 갈린다 — 화면은 둘이지만 주소가 하나뿐인
 * 게 아니라, 파라미터가 곧 단계다. 그래서 뒤로가기·새로고침이 스텝바와 어긋나지 않는다.
 */
export const EDUCATION_STEP = {
  COURSE: 1,
  SESSION: 2,
  CHECKOUT: 3,
  DONE: 4,
} as const;

export type EducationStep =
  (typeof EDUCATION_STEP)[keyof typeof EDUCATION_STEP];
